import { CommandBase } from "../CommandBase.js";

export class PwdCommand extends CommandBase {
    async execute(args) {
        // Accesses the VFS instance injected by the TerminalInterface
        this.write(this.fileSystem.getCurrentDirectory());
    }
}